export default __webpack_public_path__ + "static/media/toptri.70ae5945.svg";